var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFollowing),expression:"!isFollowing"}],staticClass:"follow_button",on:{"click":_vm.follow}},[_vm._v(" "+_vm._s(_vm.$t('followAction2'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }